import { z } from 'zod';

export const baseAppletVariableValue = z.union([ z.string(), z.number(), z.boolean(), z.null() ]);

export const baseAppletVariableSchema = z.object({
    name: z.string().min(1),
    // adding an order idx so the ordering of applet variables remains intact WRT the order in which the user added them in UI
    idx: z.number().default(-1),
    defaultValue: baseAppletVariableValue,
    sparkplug: z.object({
        tracked: z.boolean().default(false),
        writable: z.boolean().default(false),
    }),
});

export const appletVariableValueSchema = z.union([ z.string(), z.number(), z.boolean(), z.null() ]);
export type AppletVariableValue = z.infer<typeof appletVariableValueSchema>;

const baseGeneratedAppletVariableSchema = baseAppletVariableSchema.extend({
    kind: z.literal('generated'),
    generatedByMacroId: z.string().min(1),
});

export const generatedAppletVariableCfgSchema = z.discriminatedUnion('type', [
    baseGeneratedAppletVariableSchema.extend({
        type: z.literal('num'),
        defaultValue: z.number(),
    }),
    baseGeneratedAppletVariableSchema.extend({
        type: z.literal('str'),
        defaultValue: z.string(),
    }),
    baseGeneratedAppletVariableSchema.extend({
        type: z.literal('bool'),
        defaultValue: z.boolean(),
    }),
    baseGeneratedAppletVariableSchema.extend({
        defaultValue: z.null(),
        type: z.literal('empty'),
    }),
]);

export function varOrConstSchema <ValidResult extends AppletVariableValue = AppletVariableValue> (validResultSchema: z.ZodType<ValidResult> = appletVariableValueSchema as unknown as z.ZodType<ValidResult>) {
    return z.discriminatedUnion('type', [
        z.object({
            type: z.literal('var'),
            varId: z.string().min(1),
        }),
        z.object({
            type: z.literal('const'),
            val: validResultSchema,
        }),
    ]);
}
